import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * カテゴリアイテム数
 */
export class CategoryItemCount extends PrimitiveValueObject<number> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: number): CategoryItemCount {
    if (value < 0) {
      throw new Error('正数である必要があります');
    }
    return new CategoryItemCount(value);
  }

  /**
   * キー
   */
  static get key(): string {
    return 'categoryItemCount';
  }

  /**
   * タイプ
   */
  static get type(): string {
    return 'number';
  }

  /**
   * ラベル
   */
  static get label(): string {
    return '項目の表示数';
  }

  /**
   * PlaceHolder
   */
  static get placeholder(): string {
    return '0';
  }

  /**
   * バリデーションルール
   */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /**
   * 表示を返す
   * @returns 表示
   */
  override toString() {
    return this.value.toString();
  }
}
